module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5yB65"))).then(() => parcelRequire('1iHdE'));